import React from 'react'
import { TextHeading } from '@/components'

const AirdropHeading: React.FC = () => {
  return (
    <>
      <TextHeading>Airdrop</TextHeading>
    </>
  )
}

export { AirdropHeading }
